module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/secondStep-3c04ada3214175af6007e1cfa55fc4c0.png";